import { InfrastructureSection } from '@/components/dashboard/sections/InfrastructureSection'
import { TreasuryOnchainSection } from '@/components/infrastructure/TreasuryOnchainSection'
import { BackendServicesSection } from '@/components/infrastructure/BackendServicesSection'
import { CronHealthSection } from '@/components/infrastructure/CronHealthSection'
import { CloudflareSection } from '@/components/infrastructure/CloudflareSection'

export function InfrastructurePage() {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <h2 className="text-xl sm:text-2xl font-bold">Infrastructure</h2>
        <p className="text-sm sm:text-base text-muted-foreground">
          Real-time operational health across all dextoro services.
        </p>
      </div>

      {/* Relocated from /dashboard: vanity mints + verified tokens + pending fee routes */}
      <InfrastructureSection />

      {/* Section 1: Treasury & On-Chain Health */}
      <TreasuryOnchainSection />

      {/* Section 2: Backend Services Health */}
      <BackendServicesSection />

      {/* Section 3: Cron Jobs */}
      <CronHealthSection />

      {/* Section 4: Cloudflare (Pages, Workers, WAF) */}
      <CloudflareSection />
    </div>
  )
}
